<template>
  <v-list-item
    v-if="item.authorized"
    :href="href"
    :rel="href && href !== '#' ? 'noopener' : undefined"
    :target="href && href !== '#' ? '_blank' : undefined"
    :to="item.to"
    :active-class="`primary--text`"
    style="position: relative"
  >
    <v-divider
      v-if="(!expandOnHover || hovered) && $route.fullPath == item.to"
      vertical
      class="customDivider"
      :class="$route.fullPath == item.to ? 'primary' : 'background'"
    ></v-divider>
    <v-list-item-icon v-if="item.icon" :class="!expandOnHover || hovered ? 'ml-2' : ''" class="sicon">
      <v-icon :color="$route.fullPath != item.to ? 'side_bar_icon' : 'side_bar_active_icon'" class="sicon"> mdi-{{ item.icon }} </v-icon>
    </v-list-item-icon>

    <v-list-item-content v-if="item.title" :class="!expandOnHover || hovered ? 'ml-2' : ''">
      <v-list-item-title
        :class="$route.fullPath == item.to ? 'side_bar_active_text--text' : 'side_bar_text--text'"
        class="custom-list-font"
        v-text="item.title"
      />
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { mapState, mapActions } from "vuex";
export default {
  name: "BaseItem",

  mixins: [Themeable],

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
    hovered: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({
        href: undefined,
        icon: undefined,
        title: undefined,
        to: undefined,
      }),
    },
    text: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    this.checkMenuRole(this.item.role).then((response) => {
      this.$set(this.item, "authorized", response);
    });
  },

  computed: {
    ...mapState("auth", ["userRoleList"]),
    href() {
      return this.item.href || (!this.item.to ? "#" : undefined);
    },
  },

  methods: {
    ...mapActions("auth", ["checkMenuRole"]),
  },
};
</script>
<style scoped>
.custom-list-font {
  font-size: 17px;
  line-height: 1.5em;
  font-family: "Roboto", sans-serif;
}

.customDivider {
  padding: 0px 2px;
  position: absolute !important;
  left: 0;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}

.v-application--is-ltr #main-sidebar .v-list-group .v-list-group__items > .v-list-item .v-icon,
.v-application--is-ltr #main-sidebar .v-list-group .sicon {
  font-size: 18px;
  margin: auto;
  visibility: visible;
}
</style>
